import { render, staticRenderFns } from "./CatalogMiniature.vue?vue&type=template&id=2ddbae7b&scoped=true"
import script from "./CatalogMiniature.vue?vue&type=script&lang=ts"
export * from "./CatalogMiniature.vue?vue&type=script&lang=ts"
import style0 from "./CatalogMiniature.vue?vue&type=style&index=0&id=2ddbae7b&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2ddbae7b",
  null
  
)

export default component.exports